/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { produitOrganisationSchema } from "../produitOrganisationSchema.ts";
import { updateProduitOrganisationSchema } from "../updateProduitOrganisationSchema.ts";
import { z } from "zod";

export const updateProduitOrganisationPathParamsSchema = z.object({
      "officeOid": z.string().describe("ID unique du produit organisation."),
  "id": z.coerce.number().int().describe("ID de la ligne produit_organisation à mettre à jour.")
      })

/**
 * @description Le produit organisation est mis à jour avec succès.
 */
export const updateProduitOrganisation200Schema = z.lazy(() => produitOrganisationSchema)

/**
 * @description error occurred - see status code and problem object for more information.
 */
export const updateProduitOrganisation403Schema = z.object({
      "type": z.string().url().default("about:blank").describe("An absolute URI that identifies the problem type. When dereferenced,\nit SHOULD provide human-readable documentation for the problem type\n(e.g., using HTML).\n"),
  "title": z.string().describe("A short, summary of the problem type. Written in english and readable\nfor engineers (usually not suited for non technical stakeholders and\nnot localized); example: Service Unavailable\n").optional(),
  "status": z.number().int().min(100).max(600).describe("The HTTP status code generated by the origin server for this occurrence\nof the problem.\n").optional(),
  "detail": z.string().describe("A human readable explanation specific to this occurrence of the\nproblem.\n").optional(),
  "instance": z.string().url().describe("An absolute URI that identifies the specific occurrence of the problem.\nIt may or may not yield further information if dereferenced.\n").optional(),
  "properties": z.object({
      
      }).catchall(z.any()).describe("Additional properties that can be used to store any additional information\nabout the problem. This is useful for providing more context or details\nabout the error.\n").optional()
      })

export const updateProduitOrganisationMutationRequestSchema = z.lazy(() => updateProduitOrganisationSchema)

export const updateProduitOrganisationMutationResponseSchema = z.lazy(() => updateProduitOrganisation200Schema)